import styled from '@emotion/styled';

export const LiabilitiesContent = styled('div', { label: 'LiabilitiesContent' })`
    display: flex;
    flex-flow: row nowrap;
`;

export const LiabilitiesListWrapper = styled('div', { label: 'LiabilitiesListWrapper' })`
    flex: 0 0 16.6667%;
    margin-right: 10px;
`;

export const LiabilitiesWidgetsWrapper = styled('div', { label: 'LiabilitiesWidgetsWrapper' })`
    flex: 1 1 0%;
`;
